import * as AnnouncementConstants from "../constants/announcement.constant";
import { Loading } from "../utils/helpers/constants";
import { deleteItemHelper } from "../utils/helpers/dataHelper";
import { modifyList } from "../utils/helpers/dataHelper";

const initialState = {
  announcements: [],
  announcement: {},
  announcementLoading: false,
  deleteStatusState: false,
  announcementStatusLoading: false,
};

const setLoading = (state, action) => {
  const actionLoading = { ...state.announcementLoading };
  const { loading, id } = action.payload;
  actionLoading[id] = loading;
  return actionLoading;
};

const announcementReducer = (state = initialState, action) => {
  const currentAnnouncementList = [...state.announcements];
  switch (action.type) {
    case AnnouncementConstants.CREATE_ANNOUNCEMENT_REQUEST:
      return { ...state, announcementLoading: Loading.FETCHING };
    case AnnouncementConstants.CREATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        announcementLoading: Loading.SUCCESS,
      };
    case AnnouncementConstants.CREATE_ANNOUNCEMENT_FAILURE:
      return { ...state, announcementLoading: Loading.FAILED };

    case AnnouncementConstants.FETCH_ALL_ANNOUNCEMENT_REQUEST:
      return { ...state, announcementLoading: Loading.FETCHING };
    case AnnouncementConstants.FETCH_ALL_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        announcements: action.payload.announcementList,
        announcementLoading: Loading.SUCCESS,
      };
    case AnnouncementConstants.FETCH_ALL_ANNOUNCEMENT_FAILURE:
      return { ...state, announcementLoading: Loading.FAILED };

    case AnnouncementConstants.FETCH_ANNOUNCEMENT_REQUEST:
      return { ...state, announcementLoading: Loading.FETCHING };
    case AnnouncementConstants.FETCH_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        announcement: action.payload,
        announcementLoading: Loading.SUCCESS,
      };
    case AnnouncementConstants.FETCH_ANNOUNCEMENT_FAILURE:
      return { ...state, announcementLoading: Loading.FAILED };

    case AnnouncementConstants.DELETE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        deleteStatusState: setLoading(state, action),
      };
    case AnnouncementConstants.DELETE_ANNOUNCEMENT_SUCCESS:
      const newList = deleteItemHelper(
        currentAnnouncementList,
        action.payload.id,
        "id"
      );
      return {
        ...state,
        announcements: newList,
        deleteStatusState: setLoading(state, action),
      };
    case AnnouncementConstants.DELETE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        deleteStatusState: setLoading(state, action),
      };

    case AnnouncementConstants.ANNOUNCEMENT_APPROVAL_REQUEST:
      return {
        ...state,
        announcementStatusLoading: setLoading(state, action),
      };
    case AnnouncementConstants.ANNOUNCEMENT_APPROVAL_SUCCESS:
      const modifiedList = modifyList(
        currentAnnouncementList,
        action.payload.id,
        "id",
        "approved"
      );
      return {
        ...state,
        announcements: modifiedList,
        announcementStatusLoading: setLoading(state, action),
      };
    case AnnouncementConstants.ANNOUNCEMENT_APPROVAL_FAILURE:
      return { ...state, announcementStatusLoading: setLoading(state, action) };
    default:
      return state;
  }
};

export default announcementReducer;
